import React, { useState, useEffect } from "react";
import "./creatorData.scss";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import * as nftActions from "../../store/actions/nftActions";
import { filterNFTByChain } from "../../store/actions/nftActions";
import { useDispatch, useSelector } from "react-redux";
import { nftFeatureKey } from "../../store/featureKeys";

const CreatorData = () => {
  let dispatch = useDispatch();
  const [filterPrice, setFilterPrice] = useState("Ethereum");
  const [shortBy, setShortBy] = useState("recent");
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(9999);
  const nftData = useSelector((state) => state[nftFeatureKey]);
  const handleDropdown = (event) => {
    setFilterPrice(event.target.value);
  };
  let [tags, setTags] = useState([]);
  let [tag, setTag] = useState("");

  useEffect(() => {
    dispatch(
      nftActions.fetchNFTWithFilter(
        nftData.searchedName,
        filterPrice,
        tags,
        min,
        max,
        shortBy
      )
    );
  }, [filterPrice, tags, min, max, shortBy, nftData.searchedName]);

  const handleTagQuery = (event) => {
    if (event.key === "Enter" && tag !== "") {
      console.log("enter press here! ", tags);
      setTags((prevState) => [...prevState, tag]);
    }
  };

  return (
    <div className="creator-filter-wrapper">
      <div className="section-one">
        <div className="title-tag">Chain</div>
        <div className="price-dropdown">
          <FormControl
            className="explore-dropdown"
            sx={{
              width: "100%",
              bgcolor: "white",
            }}
          >
            <Select
              value={filterPrice}
              onChange={handleDropdown}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              className="w-max-100"
              MenuProps={{
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "center",
                },
              }}
            >
              <MenuItem value={"all"}>All</MenuItem>

              <MenuItem value={"Ethereum"}>Ethereum</MenuItem>
              <MenuItem value={"Polygon"}>Polygon</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="price-min-max-container">
          <div className="price-input-container">
            <input
              placeholder="min"
              className="price-input w-139"
              type="text"
              onChange={(e) => {
                setMin(e.target.value);
              }}
            />
          </div>
          <div className="or-text">or</div>
          <div className="price-input-container">
            <input
              placeholder="max"
              className="price-input w-139"
              type="text"
              onChange={(e) => {
                setMax(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
      <div className="section-two">
        <div className="title-tag" style={{ marginBottom: 0 }}>
          Tags
        </div>
        <div className="search-box">
          <div className="icon-container p13">
            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="8.31357"
                cy="8.63516"
                r="7.04599"
                stroke="white"
                stroke-opacity="0.6"
                stroke-width="1.59576"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.2148 13.9017L15.9773 16.6569"
                stroke="white"
                stroke-opacity="0.6"
                stroke-width="1.59576"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="price-input-container">
            <input
              onChange={(e) => {
                e.preventDefault();
                setTag(e.target.value);
              }}
              onKeyPress={handleTagQuery}
              placeholder="max"
              className="price-input w295"
              type="text"
            />
          </div>
        </div>
        <div className="search-tags-wrapper">
          {tags.map((tag, index) => {
            return (
              <div key={index} className="search-tag">
                <div className="text">{tag}</div>
                <div
                  className="icon"
                  onClick={(e) => {
                    e.preventDefault();
                    setTags((prevState) =>
                      prevState.filter((eachTag) => eachTag !== tag)
                    );
                  }}
                >
                  <svg
                    width="9"
                    height="10"
                    viewBox="0 0 9 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.89067 3.39083C4.22719 3.72735 4.77281 3.72735 5.10933 3.39083L7.50024 0.999922C7.77634 0.723823 8.22398 0.723823 8.50008 0.999922C8.77618 1.27602 8.77618 1.72367 8.50008 1.99976L6.10917 4.39067C5.77265 4.72719 5.77265 5.27281 6.10917 5.60933L8.50008 8.00024C8.77618 8.27634 8.77618 8.72398 8.50008 9.00008C8.22398 9.27618 7.77634 9.27618 7.50024 9.00008L5.10933 6.60917C4.77281 6.27265 4.22719 6.27265 3.89067 6.60917L1.49976 9.00008C1.22367 9.27618 0.77602 9.27618 0.499922 9.00008C0.223823 8.72398 0.223822 8.27634 0.499921 8.00024L2.89083 5.60933C3.22735 5.27281 3.22735 4.7272 2.89083 4.39067L0.499922 1.99976C0.223823 1.72367 0.223823 1.27602 0.499921 0.999921C0.77602 0.723823 1.22367 0.723822 1.49976 0.999921L3.89067 3.39083Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="section-three">
        <div className="title-tag">Sort By</div>
        <div className="price-dropdown">
          <FormControl
            className="price-dropdown"
            sx={{
              minWidth: 120,
              bgcolor: "white",
            }}
          >
            <Select
              value={shortBy}
              onChange={(e) => {
                setShortBy(e.target.value);
              }}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value={"recent"}>recently added</MenuItem>
              <MenuItem value={"price low to high"}>Price Low to High</MenuItem>
              <MenuItem value={"price high to low"}>Price High to Low</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  );
};
export default CreatorData;
